
import { ICountryCode } from 'src/stores/signup/interface';
// tslint:disable-next-line: no-var-requires
const countryTelData = require('country-telephone-data');

function isCommontownApp() {
  return window.navigator.userAgent.includes('CommontownMemberApp');
}

function getCountryCallingCodes(): any[] {
  const currentTenantCode = countryTelData.allCountries.find((code: ICountryCode) => code.iso2 === process.env.REACT_APP_TENANT);
  const countryCodeExceptCurrentTenant = countryTelData.allCountries.filter((code: ICountryCode) => code.iso2 !== process.env.REACT_APP_TENANT);
  
  return currentTenantCode === undefined ? countryTelData.allCountries : [currentTenantCode, ...countryCodeExceptCurrentTenant];;
}

export const replaceImageUrl= (imageUrl: string) => {
  return imageUrl.replace(/ /g, '%20');
}

export default { isCommontownApp, getCountryCallingCodes };



// WEBPACK FOOTER //
// ./src/modules/utils.ts